export const initialWindowSizeProps = {
  initialWidth: window.innerWidth,
  initialHeight: window.innerHeight,
};
